import * as React from 'react';

import {QuillToolbar} from '../../rich-textarea/quill-toolbar';

type Props = {
    id: string;
};

export function QuoteTextAreaToolbar(props: Props) {
    const toolbarConfig = {
        options: ['bold', 'italic', 'bulletList', 'link'],
        buttonSize: 14,
        alignCenter: true,
    } as const;

    // @ts-expect-error
    return <QuillToolbar id={props.id} config={toolbarConfig} />;
}
